module.exports = __webpack_public_path__ + "img/machineThre-img2.008a5ff1.jpg";